import { ReactNode } from 'react';
import error from 'images/error.png';
import { Empty } from 'antd';
import { useTranslation } from 'react-i18next';

interface ErrorProps {
  message: ReactNode;
  description: ReactNode;
}

export default function Error({ message, description }: ErrorProps) {
  const { t } = useTranslation('error');
  return (
    <>
      <Empty
        image={error}
        description={<h4>{message || t('something_wrong')}</h4>}
      />
      {description && <span>{description}</span>}
    </>
  );
}
